/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_dd_enter = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick your dates to see the difference.`)
};

const es_dd_enter = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige tus fechas para ver la diferencia.`)
};

const de_dd_enter = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie Ihre Daten aus, um die Differenz zu sehen.`)
};

const nl_dd_enter = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kies je datums om het verschil te zien.`)
};

const fr_dd_enter = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisissez vos dates pour voir la différence.`)
};

const it_dd_enter = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scegli le tue date per vedere la differenza.`)
};

const pt_br2_dd_enter = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolha suas datas para ver a diferença.`)
};

const pt_dd_enter = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolha as suas datas para ver a diferença.`)
};

const ja_dd_enter = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日付を選択して差を確認してください。`)
};

const zh_dd_enter = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择日期以查看差值。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const dd_enter = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.dd_enter(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("dd_enter", locale)
	if (locale === "en") return en_dd_enter(inputs)
	if (locale === "es") return es_dd_enter(inputs)
	if (locale === "de") return de_dd_enter(inputs)
	if (locale === "nl") return nl_dd_enter(inputs)
	if (locale === "fr") return fr_dd_enter(inputs)
	if (locale === "it") return it_dd_enter(inputs)
	if (locale === "pt-BR") return pt_br2_dd_enter(inputs)
	if (locale === "pt") return pt_dd_enter(inputs)
	if (locale === "ja") return ja_dd_enter(inputs)
	return zh_dd_enter(inputs)
};